import { Flex } from '@revenuemarket/cds';
import { colorTokens } from '@revenuemarket/design';
import { Typography } from 'antd';

import { formatNumByTaxInvoice } from '~components/Settlement/utils';
import { TaxInvoiceType } from '~models/tax-invoice';

import useTransactionMappingStore from './TransactionMappingStore';

interface Props {
  unmappedAmount: number;
  totalAmount: number;
  taxInvoiceType: TaxInvoiceType;
  taxInvoiceId: string;
}

const MappingAmountInfoRenderer: React.FC<Props> = ({
  unmappedAmount,
  totalAmount,
  taxInvoiceType,
  taxInvoiceId,
}) => {
  const { mappedInvoices, originalMappedInvoices } = useTransactionMappingStore();

  const taxInvoiceMapped = mappedInvoices.find((invoice) => invoice.taxInvoiceId === taxInvoiceId);
  const targetMappedAmount =
    originalMappedInvoices.find((invoice) => invoice.taxInvoiceId === taxInvoiceId)?.mappedAmount ??
    0;

  const targetUnMappedAmount = taxInvoiceMapped
    ? formatNumByTaxInvoice(unmappedAmount, taxInvoiceType) +
      targetMappedAmount -
      taxInvoiceMapped.mappedAmount
    : formatNumByTaxInvoice(unmappedAmount, taxInvoiceType) + targetMappedAmount;

  return (
    <Flex direction="column" align="flex-end">
      <Typography.Text style={{ fontSize: 14 }}>{`${(
        targetUnMappedAmount || 0
      ).toLocaleString()}원`}</Typography.Text>
      <Typography.Text style={{ color: colorTokens.textDescription }}>
        {`/${totalAmount.toLocaleString()}원`}
      </Typography.Text>
    </Flex>
  );
};

export default MappingAmountInfoRenderer;
